import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/useAuth";

interface RequireAuthProps {
  children: ReactNode;
  roles?: Array<"ADMIN" | "DOZENT">;
  redirectTo?: string;
}

export const RequireAuth = ({ children, roles, redirectTo = "/login" }: RequireAuthProps) => {
  const { user, loading, sessionRefreshWarning } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "ADMIN" ? "/admin/uebersicht" : "/dozent/dashboard"} replace />;
  }

  return (
    <>
      {sessionRefreshWarning ? (
        <div
          role="status"
          aria-live="polite"
          className="fixed right-4 top-4 z-50 max-w-sm rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-medium text-amber-900 shadow-md"
        >
          {sessionRefreshWarning}
        </div>
      ) : null}
      {children}
    </>
  );
};
